module.exports = __webpack_public_path__ + "img/cate-icon-4.f056c5e5.png";